/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-10 16:17:27
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Banner, Link } from '@shopify/polaris';
import { URL } from 'src/constants/links';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

class ThemeSetupError extends Component<WithI18nProps> {
  render() {
    const { i18n } = this.props;
    return (
      <Banner title={i18n.translate('AdminHTML.ThemeSetup.ThemeSetupError.title')} status="warning">
        <p>
          {i18n.translate('AdminHTML.ThemeSetup.ThemeSetupError.content', {
            t1: (
              <Link external url={URL['SetupAppOnCertainTheme']}>
                {i18n.translate('AdminHTML.ThemeSetup.ThemeSetupError.content_t1')}
              </Link>
            )
          })}
        </p>
      </Banner>
    );
  }
}

export default withI18n()(ThemeSetupError);
